import { render, staticRenderFns } from "./IntakeTabs.vue?vue&type=template&id=c37a557a&scoped=true&"
import script from "./IntakeTabs.vue?vue&type=script&lang=js&"
export * from "./IntakeTabs.vue?vue&type=script&lang=js&"
import style0 from "./IntakeTabs.vue?vue&type=style&index=0&id=c37a557a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c37a557a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabItem,VTabs})
